import httpClient from "./httpClient";

export const ndaApi = {
  /**
   * Retrieves this user's saved draft (or default company info).
   */
  getDraft: () =>
    httpClient.get("/nda/draft", {
      maxRetries: 0, // Stops retry spamming on page load
    }),

  /**
   * Upsert the draft with custom firstParty and secondParty details.
   */
  saveDraft: (payload) =>
    httpClient.put("/nda/draft", payload, {
      maxRetries: 0,
    }),

  /**
   * Validates and generates the .docx document.
   */
  generate: (payload) =>
    httpClient.post("/nda/generate", payload, {
      responseType: "blob",
      timeout: 20000,
      maxRetries: 0,
    }),
};
